// created from 'create-ts-index'

export * from './files.socket';
